<template>
  <div id="mapDiv" class="mapDiv"></div>
</template>

<script>
// import geo from '@/api/geo'

import L from 'leaflet'
import 'proj4leaflet'
import 'esri-leaflet-renderers'

// New import
// import predictions from '../assets/predictions.json'
// import predictions from '../assets/predictions_WGS84.json'
// import predictions from '../assets/predictions_WGS84_simplified_reduced.json'
// import predictions from '../assets/predictions_WGS84_linestring_precision_simplify_relevant.json'
// import predictions from '../assets/predictions_decisiontree_mp3.2.json'
import predictions from '../assets/predictions_WGS84_6.json'
// import predictions from '../assets/predictions_WGS84_7.json'

import Colors from '../colors'

import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    mapCenter: {
      type: Array,
      required: true
    },
    zoom: {
      type: Number,
      required: true
    },
    disableElement: {
      type: Boolean
    }
  },
  data () {
    return {
      RD: '',
      map: '',
      timeout: null,
      predictionsLayer: ''
    }
  },
  mounted () {
    this.mapGen({
      lat: 52,
      lng: 4.4,
      zoom: this.zoom
    })
  },
  methods: {
    ...mapMutations(['setMapsOpen', 'setMapClosed', 'setMapOpen', 'toggleMapsOpen']),
    mapGen: function (query) {
      this.createMap(query)
      this.addBackgroundTileLayer()
      this.addPredictiveLayer()
    },
    createMap (query) {
      // const RD = new L.Proj.CRS('EPSG:28992', '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +towgs84=565.2369,50.0087,465.658,-0.406857330322398,0.350732676542563,-1.8703473836068,4.0812 +no_defs',
      //   {
      //     resolutions: [3440.640, 1720.320, 860.160, 430.080, 215.040, 107.520, 53.760, 26.880, 13.440, 6.720, 3.360, 1.680, 0.840, 0.420, 0.210],
      //     bounds: L.bounds([-285401.92, 22598.08], [595401.9199999999, 903401.9199999999]),
      //     origin: [-285401.92, 22598.08]
      //   }
      // )

      this.map = L.map('mapDiv', {
        minZoom: 10,
        maxZoom: 15,
        zoom: query.zoom,
        zoomControl: false,
        center: [query.lat, query.lng],
        maxBounds: L.latLngBounds([52.4, 3.8], [51.4, 5.2])
      })

      L.control.zoom({position: 'bottomright'}).addTo(this.map)
    },
    addBackgroundTileLayer () {
      new L.TileLayer('https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/water/EPSG:3857/{z}/{x}/{y}.png', {
        attribution: 'Map data: <a href="http://www.kadaster.nl">Kadaster</a>'
      }).addTo(this.map)
    },
    addPredictiveLayer () {
      const curYear = this.filters.year || new Date().getFullYear()
      const getStyle = (feature) => {
        // console.log(feature)
        let fillColor = ''
        const lane = feature.properties.lane.toLowerCase()
        // const rut = 'rut_${lane}_'
        // Om de oude dataset te gebruiken constant rut zonder p_ gebruiken sinds de dataset op die wijze aangepast is.
        const rut = `rut_${lane}_p_`
        const rut2 = `rut_${lane}_`

        let rutYear = rut + curYear
        let rutYear2 = rut2 + curYear
        if (feature.properties[rutYear] || feature.properties[rutYear2]) {
          const thresholds = feature.properties[rutYear]
          const thresholds2 = feature.properties[rutYear2]
          if (thresholds <= 7.5 || thresholds2 <= 7.5) {
            fillColor = Colors.Green
          } else if ((thresholds > 7.5 && thresholds < 10) || (thresholds2 > 7.5 && thresholds2 < 10)) {
            fillColor = Colors.Orange
          } else {
            fillColor = Colors.Red
          }
        }

        return {
          weight: 3,
          opacity: 1,
          fillOpacity: 0.6,
          color: fillColor,
          fillColor: fillColor
        }
      }

      const onEachFeature = (feature, layer) => {
        layer.on({
          click: this.zoomtoFeature
        })
      }

      const geojson = L.geoJson(null, {
        style: getStyle,
        onEachFeature: onEachFeature
      })
        .bindTooltip(function (layer) {
          return `
            <div class="leaflet-tooltip-content">
              <div>Traject</div>
              <div>${layer.feature.properties.beheer_object}</div>
            </div>
          `
        }, {sticky: false, direction: 'top'})

      geojson.addData(this.filterPredictions())
        .on('add', layer => {
          if (this.predictions.length && this.predictions.length <= 2) {
            let zoomToLayer = null
            this.map.eachLayer((mapLayer) => {
              const objectId = this.predictions[0].properties.OBJECTID
              if (mapLayer.feature && objectId === mapLayer.feature.properties.OBJECTID) {
                zoomToLayer = mapLayer
              }
            })

            if (zoomToLayer) {
              const newLayer = {target: zoomToLayer}
              newLayer.target.feature = {
                properties: this.predictions.length ? this.predictions[0].properties : {}
              }

              this.zoomtoFeature(newLayer)
            }
            // this.zoomtoFeature(layer) old zoom to filtered predictions
          }
        })

      this.predictionsLayer = geojson
      this.map.addLayer(this.predictionsLayer)
    },
    zoomtoFeature (e) {
      console.log(e.target.feature)
      const t = e.target.feature.properties
      const filteredPredictions = Object.assign({}, predictions)

      this.map.fitBounds(e.target.getBounds())

      this.$store.dispatch('setTrajectory', e.target.feature.properties)

      filteredPredictions.features = filteredPredictions.features.filter(feature => feature.properties.object_id === t.object_id && t.lane !== feature.properties.lane)[0]

      if (filteredPredictions.features) {
        if (t.lane === 'L') {
          this.$store.dispatch('setTrajectories', [t, filteredPredictions.features.properties])
        } else {
          this.$store.dispatch('setTrajectories', [filteredPredictions.features.properties, t])
        }
      }
    },
    filterPredictions () {
      const foundNway = []
      const filteredPredictions = Object.assign({}, predictions)

      if (this.filters.nway || this.filters.nway === null) {
        filteredPredictions.features = filteredPredictions.features.filter((feature, index) => {
          let filterByNWay = false
          const nway = feature.properties['beheer_object'].toLowerCase()
          const included = foundNway.includes(nway)

          if (this.filters.nway) {
            if (nway.includes(this.filters.nway.toLowerCase()) && !included) {
              foundNway.push(nway)
              filterByNWay = true
            }
          } else if (!included) {
            foundNway.push(nway)
            filterByNWay = true
          }

          return filterByNWay
        })

        this.$store.dispatch('setPredictions', filteredPredictions.features)
      }

      return predictions
      // return filteredPredictions
    }
  },
  computed: {
    ...mapState(['mapsOpen', 'zoomLevel']),
    ...mapState('projects', ['filters']),
    ...mapState(['predictions'])
  },
  watch: {
    filters: function (oldFilter, newFilter) {
      const onChangeFilters = () => {
        this.predictionsLayer.remove()
        this.addPredictiveLayer()
      }
      clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => onChangeFilters(), 350)

      if (!newFilter['nway']) { // Restore zoom & bounds on empty nway to initial value
        // this.map.setView([52, 4.4], this.zoom)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.mapDiv
  flex: 1
  z-index: 0
  background-color: none !important
</style>
<style lang="sass">
.leaflet-tooltip-content
  // background-color: hotpink !important

.leaflet-tooltip-pane
  // background: purple !important
  // color: #fff !important
  // font-size: 10px
  // line-height: 10px

.class-popup .leaflet-popup-content-wrapper a
  // color: #2980b9 !important

.class-popup .leaflet-popup-tip-container
  // width: 40px
  // height: 20px

.class-popup .leaflet-popup-tip
  // background: #2980b9 !important
</style>



// WEBPACK FOOTER //
// src/components/mapDetails.vue